import { render, staticRenderFns } from "./RsaRiepiloghiRiepilogoImpegnativeListComponent.vue?vue&type=template&id=ec1935ca&scoped=true"
import script from "./RsaRiepiloghiRiepilogoImpegnativeListComponent.vue?vue&type=script&lang=js"
export * from "./RsaRiepiloghiRiepilogoImpegnativeListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1935ca",
  null
  
)

export default component.exports